"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignSpeakers = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _AssignSpeakers = require("./AssignSpeakers.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _ = require("./..");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AssignSpeakers = exports.AssignSpeakers = function AssignSpeakers(_ref) {
  var hostSources = _ref.hostSources,
    speakerSources = _ref.speakerSources,
    onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    _ref$previouslySelect = _ref.previouslySelectedSpeakers,
    previouslySelectedSpeakers = _ref$previouslySelect === void 0 ? [] : _ref$previouslySelect;
  var _useState = (0, _react.useState)(previouslySelectedSpeakers),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedSpeakerIds = _useState2[0],
    setSelectedSpeakerIds = _useState2[1];
  var toggleSource = function toggleSource(sourceId) {
    setSelectedSpeakerIds(function (previousSpeakers) {
      if (previousSpeakers.includes(sourceId)) {
        return previousSpeakers.filter(function (speakerId) {
          return speakerId !== sourceId;
        });
      } else {
        return [].concat((0, _toConsumableArray2["default"])(previousSpeakers), [sourceId]);
      }
    });
  };
  var selectAll = function selectAll() {
    var speakerSourcesId = speakerSources.map(function (source) {
      return source === null || source === void 0 ? void 0 : source.user;
    });
    setSelectedSpeakerIds(speakerSourcesId);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledHeader, null, "Assign speakers"), /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledText, null, "No more 'Next slide please'. Let speakers control their own slides."), /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledSpeakersWrapper, null, /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.SelectAllSource, {
    onClick: selectAll,
    "data-testid": "select-all-button"
  }, "Select all"), hostSources.map(function (source) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, {
      check: true,
      key: source === null || source === void 0 ? void 0 : source.user
    }, /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledDisabledCheckbox, {
      type: "checkbox",
      onChange: function onChange() {},
      "data-testid": "speaker-checkbox-".concat(source === null || source === void 0 ? void 0 : source.user),
      checked: true
    }), /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledSourceLabel, {
      check: true
    }, source.title, " (host)"));
  }), speakerSources.map(function (source) {
    return /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.ClickableSpeaker, {
      check: true,
      key: source === null || source === void 0 ? void 0 : source.user
    }, /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledCheckbox, {
      type: "checkbox",
      id: "speaker-checkbox-".concat(source === null || source === void 0 ? void 0 : source.user),
      "data-testid": "speaker-checkbox-".concat(source === null || source === void 0 ? void 0 : source.user),
      checked: selectedSpeakerIds.includes(source === null || source === void 0 ? void 0 : source.user),
      onChange: function onChange() {
        return toggleSource(source === null || source === void 0 ? void 0 : source.user);
      }
    }), /*#__PURE__*/_react["default"].createElement(_AssignSpeakers.StyledSourceLabel, {
      "for": "speaker-checkbox-".concat(source === null || source === void 0 ? void 0 : source.user),
      check: true
    }, source.title));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end mt-4"
  }, /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "save-button",
    onClick: function onClick(e) {
      e.preventDefault();
      onSave(selectedSpeakerIds);
    }
  }, "Save"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "cancel-button",
    color: "light",
    variant: "ghost",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Cancel")));
};
AssignSpeakers.propTypes = {
  hostSources: _propTypes["default"].array.isRequired,
  speakerSources: _propTypes["default"].array.isRequired,
  onSave: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  previouslySelectedSpeakers: _propTypes["default"].array
};